import {
  FILTER_AMOUNT_DOWN,
  FILTER_AMOUNT_UP,
  FILTER_CLIENT_BY_INSTRUMENT_NAME,
  FILTER_CLIENT_NAME,
  FILTER_CURRENCY_NAME,
  FILTER_DATE_FROM,
  FILTER_DATE_TO,
  FILTER_INSTRUMENT_NAME,
  FILTER_MARKET_NAME,
  FILTER_ORDER_TYPE,
  FILTER_PORTFOLIO_DETAIL,
  FILTER_SEARCH_ALL,
  ORDER_CLIENTS,
  SORT_ORDERS,
  TRADER_DIARY_TABLE,
} from '../actionTypes'
import { ClientSortOptions, OrdersByStateOptions, TraderDiaryByStateOptions } from '../reducers/filters'

export const filterClientName = (searchedClientName: string) => ({
  type: FILTER_CLIENT_NAME,
  payload: searchedClientName,
})

export const filterDateFrom = (searchedDateFrom: Date) => ({
  type: FILTER_DATE_FROM,
  payload: searchedDateFrom,
})

export const filterDateTo = (searchedDateTo: Date) => ({
  type: FILTER_DATE_TO,
  payload: searchedDateTo,
})

export const sortClients = (value: string) => ({
  type: ORDER_CLIENTS,
  payload: value,
})

export const filterPortfolioDetail = (name: string, value: boolean) => ({
  type: FILTER_PORTFOLIO_DETAIL,
  payload: { name, value },
})

export const filterInstrumentName = (searchedInstrumentName: string) => ({
  type: FILTER_INSTRUMENT_NAME,
  payload: searchedInstrumentName,
})

export const filterMarketName = (searchedMarketName: string) => ({
  type: FILTER_MARKET_NAME,
  payload: searchedMarketName,
})

export const searchAllName = (searchAll: boolean) => ({
  type: FILTER_SEARCH_ALL,
  payload: searchAll,
})

export const filterClientAmountUp = (searchedAmountUp: string) => ({
  type: FILTER_AMOUNT_UP,
  payload: searchedAmountUp,
})

export const filterClientAmountDown = (searchedAmountDown: string) => ({
  type: FILTER_AMOUNT_DOWN,
  payload: searchedAmountDown,
})

export const filterClientByInstrumentName = (searchedClientByInstrumentName: string) => ({
  type: FILTER_CLIENT_BY_INSTRUMENT_NAME,
  payload: searchedClientByInstrumentName,
})

export const sortOrderTable = (value: OrdersByStateOptions) => ({ type: SORT_ORDERS, payload: value })

export const filterCurrencyName = (searchedCurrencyName: string) => ({
  type: FILTER_CURRENCY_NAME,
  payload: searchedCurrencyName,
})

export const filterOrderType = (searchedOrderType: string) => ({
  type: FILTER_ORDER_TYPE,
  payload: searchedOrderType,
})

export const sortTradeDiaryTable = (value: TraderDiaryByStateOptions) => ({ type: TRADER_DIARY_TABLE, payload: value })